import React from "react";
import "./App.css";

function TermsOfService() {
  window.document.title = '사고링크:마케팅 정보 수신'
  return (
    <>
      <div class="Wrapper">
        <div class="largeTitle">
          <strong>마케팅정보수신</strong>
        </div>
        <div class="text">
        주식회사 사고링크는 사고링크의 모든 회원들께 더 나은 서비스를 제공하고자 광고･마케팅 목적의 개인정보 수집 및 이용에 대한 동의를 받고자 합니다. 내용을 자세히 읽으신 후, 동의를 원하시면 원래의 화면으로 돌아가 동의 절차를 진행해주시기 바랍니다. 보다 자세한 내용은 홈페이지에 게시된 개인정보처리방침을 참조하여 주시기 바랍니다.
        </div>
        <br />
        <div class="subtitle">
          <strong>제 1조 (목적)</strong>
        </div>
        <br />
        <div class="text">사고링크의 상품･서비스에 대한 광고･홍보･프로모션 제공</div>
        <br />
        <br />

        <div class="subtitle">
          <strong>제 2조 (처리하는 개인정보 항목)</strong>
        </div>
        <br />
        <div class="text">이름, 휴대전화번호, 이메일주소 등 개인정보</div>
        <br />
        <br />

        <div class="subtitle">
          <strong>제 3조 (보유 및 이용기간)</strong>
        </div>
        <br />
        <div class="text">동의 철회 시 또는 회원 탈퇴 시까지</div>
        <br />
        <br />
        <div class="subtitle">
          <strong>제 4조 (제3자 제공에 대한 안내)</strong>
        </div>
        <br />
        <div class="text">
        본 광고･마케팅 수신 동의는 광고･마케팅에 관련한 내용을 문자, 앱 푸시, 카카오톡 등으로 ‘수신’할 것인지에 대한 동의입니다. 따라서, 제휴사에 개인신용정보를 제공하는 경우에는 별도의 동의를 받을 것입니다.
        </div>
        <br />
        <br />

        <div class="subtitle">
          <strong>제 5조 (동의거부에 대한 안내)</strong>
        </div>
        <br />
        <div class="text">
        본 광고･마케팅 수신 동의는 선택 사항이며, 동의를 거부할 수 있습니다. 동의를 거부하는 경우에도 다른 사고링크 서비스의 이용에는 영향이 없습니다. 또한, 본 광고･마케팅 수신 동의는 내정보에서 언제든지 철회할 수 있습니다. 본 동의를 유지하는 경우, 2년마다 광고･마케팅 수신 동의 상태를 알려 드립니다.
        </div>
        <br />
        <br />
      </div>
    </>
  );
}

export default TermsOfService;
